import Nanobus from "nanobus";
export default class Cell {
    constructor(id, name, el) {
        this.object_id = id;
        this.column_name = name;
        this.original_value = el.innerHTML;
        this.el = el;
        this.services = {};
        this.events = new Nanobus();
    }
    getOriginalValue() {
        return this.original_value;
    }
    getObjectID() {
        return this.object_id;
    }
    getName() {
        return this.column_name;
    }
    getElement() {
        return this.el;
    }
    setElement(element) {
        this.el = element;
    }
    getRow() {
        return this.el.parentElement;
    }
    getSettings() {
        return AC_SERVICES.getService('Table').Columns.get(this.getName());
    }
    hasChanged(content) {
        return this.original_value !== content;
    }
    setValue(value) {
        let rowActions = this.el.querySelector('.row-actions');
        this.original_value = value;
        this.el.innerHTML = value;
        if (rowActions) {
            this.el.append(rowActions);
        }
        this.original_value = value;
        this.events.emit('setValue', this);
        return this;
    }
    setService(name, service) {
        this.services[name] = service;
    }
    getService(name) {
        return this.hasService(name) ? this.services[name] : null;
    }
    hasService(name) {
        return this.services.hasOwnProperty(name);
    }
}
